import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import SelectBoolean from './SelectBoolean';

const SelectReceiptIsPro = ({t, onChange, value, ...props}) => {
  return (
    <SelectBoolean
      name={'isPro'}
      value={value}
      allowNull
      typeTitle={t('selectReceiptIsPro.title')}
      onChange={onChange}
      customAllText={t('selectReceiptIsPro.all')}
      customTrueText={t('selectReceiptIsPro.true')}
      customFalseText={t('selectReceiptIsPro.false')}
      {...props}
    />
  );
};

SelectReceiptIsPro.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default withTranslation('common')(SelectReceiptIsPro);
